import * as constants from './constants';
import defaultState from '../state';
import { shuffleSuggestions } from './utils';

const suggestionsInitialState = defaultState.suggestions;

export default (state = suggestionsInitialState, action) => {
  switch (action.type) {
    case constants.FETCH_SUGGESTIONS_START: {
      return {
        ...state,
        data: [],
      };
    }

    case constants.FETCH_SUGGESTIONS_SUCCESS: {
      const suggestions = shuffleSuggestions(action.data.suggestions);
      return {
        ...state,
        data: suggestions || [],
        error: null,
      };
    }

    case constants.FETCH_SUGGESTIONS_FAILED: {
      return {
        ...state,
        data: [],
        error: action.error,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/Suggestions/reducer.js